import { useState } from 'react';
import { FileClient, ApiResponse_string, ApiResponse_fileUrlResponseDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';
import { handleHookError } from '../utils/hookUtils/handleHookError';

export const useFileApi = () => {
    const apiClient = new FileClient(API_BASE_URL, axiosInstance);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const uploadFile = async (
        containerName: string,
        fileName: string,
        file: File,
        folder?: string
    ): Promise<ApiResponse_string> => {
        setIsLoading(true);
        try {
            return await apiClient.uploadFile(containerName, fileName, folder, file);
        } catch (err: unknown) {
            handleHookError(err, 'Error uploading file', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const getFileUrl = async (
        fileRecordId: string,
    ): Promise<ApiResponse_fileUrlResponseDTO> => {
        setIsLoading(true);
        try {
            return await apiClient.getFileUrl(fileRecordId);
        } catch (err: unknown) {
            handleHookError(err, 'Error getting file URL', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        uploadFile,
        getFileUrl,
        isLoading,
        error
    };
};
